import { login, logout } from '@modules/auth';
import { useDispatch } from '@stores';
import { ILoginResponse } from '@types';
import { useCallback } from 'react';

const useAuthActions = () => {
  const dispatch = useDispatch();

  const onLogin = useCallback(
    (payload: ILoginResponse) => {
      dispatch(login(payload));
    },
    [dispatch]
  );

  const onLogout = useCallback(() => {
    dispatch(logout());
  }, []);

  return { onLogin, onLogout };
};

export default useAuthActions;
